import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
    selector: 'date-renderer',
    templateUrl: './date-renderer.component.html',
    standalone: true,
    imports: [CommonModule]
})
export class DateRendererComponent implements ICellRendererAngularComp {
    public text: string;

    constructor() { }

    initilize(params: ICellRendererParams) {
        this.text = params.getValue();
    }

    agInit(params: any): void {
        this.initilize(params);
    }

    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }
}
